import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from 'redux/store';

/**
 * キーワードの計測処理
 * @returns 計測処理
 */
export const measureKeywordSearch =
  (): AnalyticsAppThunk<RootState> => (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    tlReadyExecute(isAdobeScript, dispatch, 'FW_SRCHsgt_imp', {});
  };
